<template>
    <component
        :is="hasPreviewImage ? 'vx-dropdown' : 'div'"
        align="left"
        justify="start"
        class="w-full widget-holder"
        :dropdownTooltipStyle="tooltipMarginRight"
    >
        <div
            draggable
            class="droppable-element"
            @dragstart="dragStart($event, widgetComponent)"
            @dragend="dragEnd($event)"
            @mouseenter="showTooltip = true"
            @mouseleave="showTooltip = false"
        >
            <vx-card class="card widget-preview" card-border>
                <template slot="title">
                    <div class="title-container">
                        <h4 class="title">{{ title }}</h4>
                        <h6 class="subtitle" slot="subtitle">
                            {{ subtitle }}
                        </h6>
                    </div>
                    <img v-if="hasPreviewImage" :src="previewImageSrc" class="mini-preview" />
                </template>
            </vx-card>
        </div>
        <template v-if="hasPreviewImage" slot="menu">
            <img :src="previewImageSrc" class="img" />
        </template>
    </component>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'widget-preview',
    props: {
        widget: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showTooltip: false,
            previewImages: []
        }
    },
    computed: {
        ...mapGetters({ themeMode: 'user/themeMode' }),
        theme() {
            // covers semi-dark
            return this.themeMode == 'dark' ? 'dark' : 'light'
        },
        previewImageSrc() {
            if (!this.hasPreviewImage) {
                return ''
            }
            // return require(`@/components/widgets/previewImages/${this.theme}/${this.name}.png`)
        },
        widgetComponent() {
            return this.widget.component
        },
        widgetInstance() {
            return this.widget.instance
        },
        title() {
            return this.widgetInstance.title
        },
        subtitle() {
            return this.widgetInstance.subtitle
        },
        packet() {
            return {
                w: Number(this.widgetInstance.w),
                h: Number(this.widgetInstance.h),
                isResizable: this.widgetInstance.isResizable,
                defaultConfig: this.widgetInstance.defaultConfig,
                component: this.name
            }
        },
        name() {
            return this.widgetComponent.name
        },
        tooltipMarginRight() {
            return { marginRight: '11px' }
        },
        hasPreviewImage() {
            if (!this.previewImages.any()) {
                return false
            }
            var path = `./${this.theme}/${this.name}.png`
            return this.previewImages.contains(path)
        }
    },
    methods: {
        dragEnd(e) {
            this.$nextTick(() => {
                this.$emit('dragend', e)
            })
        },
        dragStart(e) {
            e.dataTransfer.setData('widget', null)
            this.$store.commit('dashboard/SET_CURRENT_DRAGGED_WIDGET', this.packet)
            this.$emit('dragstart', e)
        }
    },
    mounted() {
        // required for dynamic load of images inside previews
        this.previewImages = require.context('@/components/widgets/previewImages/', true).keys()
    }
}
</script>

<style lang="scss" scoped>
.droppable-element {
    transition: all 0.1s ease-in-out;

    &:hover {
        transform: scale(1.03);
        cursor: move;
        /* fallback if grab cursor is unsupported */
        cursor: grab;
        cursor: -moz-grab;
        cursor: -webkit-grab;

        &:active {
            cursor: grabbing;
            cursor: -moz-grabbing;
            cursor: -webkit-grabbing;
        }
    }
}
.widget-preview {
    .mini-preview {
        transition: all 0.3s ease;
        opacity: 0.6;
        position: absolute;
        top: -5px;
        min-height: 105%;
        max-width: 40%;
        object-fit: scale-down;
        left: 60%;
    }
    .title-container {
        position: absolute;
        z-index: 1;
    }

    &:hover {
        background: linear-gradient(
            90deg,
            rgba(var(--vs-success), 0.6) 0%,
            rgba(var(--vs-success), 0.35) 49%,
            rgba(var(--vs-success), 0.15) 100%
        );
        .mini-preview {
            opacity: 0.9;
        }
    }
}
.card {
    height: 100px;
    overflow: hidden;
}

.img {
    max-width: 400px;
    max-height: 400px;
    object-fit: fill;
}
</style>
